import Constants from '../utils/params';

export function handleErrors(response)
{
    if (!response.ok) {
        throw (response);
    }
    return response.json();
}

export function getMentions(token)
{
  let params = {
    headers: {'Authorization': "bearer " + token}
  };

  return fetch(`${Constants.DOMAIN}/api/mention/`, params)
  .then(handleErrors)
  .then(res=>res)
  .catch((err)=>{
    return err;
  })
}



// WEBPACK FOOTER //
// ./src/api/mention.js